var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSendEmailIcon = function SvgSendEmailIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D14339",
    d: "M11.5 2.336a5.625 5.625 0 1 0 0 11.25 5.625 5.625 0 0 0 0-11.25m-6.61 13.5a2.39 2.39 0 0 0-2.39 2.39v.422c0 2.113 1.092 3.694 2.768 4.714 1.648 1.003 3.862 1.474 6.232 1.474V16.96c0-.41.11-.794.3-1.125zm7.735 1.687a1.687 1.687 0 0 1 1.688-1.687h9A1.687 1.687 0 0 1 25 17.523v.445l-6.187 2.873-6.188-2.873zm6.424 4.448L25 19.208v5.065a1.69 1.69 0 0 1-1.687 1.688h-9a1.687 1.687 0 0 1-1.688-1.688v-5.065l5.95 2.763a.56.56 0 0 0 .474 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSendEmailIcon);
export default ForwardRef;